<template>
  <div class="vetable-container" >
    <div class="table-container">
      <ve-table
          :cell-style-option="config.cellStyleOption"
          :cellSelectionOption="config.cellSelectionOption"
          :columnHiddenOption="config.columnHiddenOption"
          :event-custom-option="config.eventCustomOption"
          :row-style-option="{stripe: true}"
          :checkbox-option="config.checkBoxOption"
          :max-height="config.maxHeight"
          :scroll-width="scrollWidth"
          id="loading-container" ref="tableRef"
          :columns="tableItem" border-y :border-x="true" :border-around="true"
          :table-data="tableData"
          :sort-option="config.sortOption"
          :row-key-field-name="config.rowKey"
          :column-width-resize-option="columnWidthResizeOption"
      />
      <div v-show="tableData.length <= 0" class="empty-data">暂无数据</div>
    </div>
    <el-pagination
        v-if="showPagenation"
        @size-change="pagenationEvent.handleSizeChange"
        @current-change="pagenationEvent.handleCurrentChange"
        :current-page="pagenationConfig.currentPage"
        :page-sizes="pagenationConfig.pageSizeList"
        :page-size="pagenationConfig.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagenationConfig.totalCount">
    </el-pagination>
    <el-dialog
        title="配置表头"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose">
      <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-button @click="recoverHandler" type="primary" size="mini">恢复默认</el-button>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group  v-model="defaultShowColumnKeys" @change="handlerCheckBoxChange">
          <el-checkbox :disabled="item.checkDisabled" v-for="item in tableItem" :label="item.key" :key="item.key">{{item.title}}</el-checkbox>
          <!--              <span v-for="(item,index) in tableItem" :key="index">{{item.title}}</span>-->
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandler">确 定</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * @tableItem:11011
 * 表头{ label: '操作', value: '查看详情', function: this.settingHandler, fixed: 'right' }
 *    @function 显示按钮的栏 跟要触发的方法
 *    @fixed 左右定位
 *    @filter 过滤器 传一个处理数据的方法
 * @tableData: 表格内容
 * @pagenationConfig 分页器参数nnids
 * @pagenationEvent 分页器出发的方法 handleSizeChange / handleCurrentChange
 */
export default {
  name: 'index',
  props: {
    showPagenation: {
      default() {
        return true
      }
    },
    tableKey: {},
    scrollWidth: {
      default() {
        return 1200
      }
    },
    config: {
    },
    showIndex: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    },
    selection: {

      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    },
    tableItem: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    },
    pagenationConfig: {
      type: Object,
      required: false,
      default: function () {
        return {
          pageSizeList: [10, 20, 50, 100, 200],
          pageSize: 10,
          currentPage: 1,
          totalCount: 100,
        }
      }
    },
    defaultShowColumn: {},
    pagenationEvent: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      tableHeight: '100px',
      color: 'red',
      isIndeterminate: false,
      checkAll: false,
      columnWidthResizeOption: {
        // default false
        enable: true,
        // column resize min width
        minWidth: 50,
        // column size change

      },

      loadingInstance: null,
      defaultShowColumnKeys: [],
      defaultHideColumnKeys: [],
      dialogVisible: false,
      multipleSelection: [],
      dontNeedHeader: false
    }
  },
  filters: {
    filterModuleHandler (obj, row, filter) {
      return filter(obj, row)
    },
  },
  computed: {

  },
  watch: {
    tableItem: {
      handler(val) {
        this.tableItem.forEach( item => {
          if(!item.width) {
            item.width = 100
          }
        })
      },
      immediate: true,
      deep: true
    },
    defaultShowColumn: {
      handler(val) {
        this.defaultShowColumnKeys = val
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if(this.tableKey) {
      let defaultHeader = localStorage.getItem(this.tableKey)
      if(defaultHeader) {
        this.defaultShowColumnKeys = JSON.parse(defaultHeader)
        this.dontNeedHeader = true
      }
    }

  },
  mounted() {
    this.loadingInstance = this.$veLoading({
      target: document.querySelector("#loading-container"),
      // 等同于
      // target:"#loading-container"
      name: "wave",
    });
    // this.show();
    // this.checkAll = this.defaultShowColumnKeys.length === this.tableItem.length
    // this.isIndeterminate = this.defaultShowColumnKeys.length > 0 && this.defaultShowColumnKeys.length < this.tableItem.length
    this.__init()
    if(this.defaultShowColumnKeys.length && this.config.hasLocalData && !this.dontNeedHeader) {
      this.confirmHandler()
    }
  },
  methods: {
    __init() {
      this.loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });
      // this.show();
      this.initTableHeader()
      this.checkAll = this.defaultShowColumnKeys.length === this.tableItem.length
      this.isIndeterminate = this.defaultShowColumnKeys.length > 0 && this.defaultShowColumnKeys.length < this.tableItem.length
    },
    hideColumns(keys) {
      console.log(1111);
      console.log(keys);
      this.$refs.tableRef.hideColumnsByKeys(keys);
    },
    // show cloumns
    showColumns(keys) {
      this.$refs["tableRef"].showColumnsByKeys(keys);
    },
    //恢复默认操作
    recoverHandler() {
      if(this.defaultShowColumn.length) {
        this.defaultShowColumnKeys = this.defaultShowColumn
      }else {
        this.defaultShowColumnKeys = this.tableItem.map(item => {
          return item.key
        })
      }
      this.handlerCheckBoxChange(this.defaultShowColumnKeys)
    },
    //全选操作
    handleCheckAllChange(val) {
      this.defaultShowColumnKeys = val ? this.tableItem.map(item => item.key) : this.tableItem.map(item => {
        if(item.checkDisabled) {
          return item.key
        }
      })
      this.isIndeterminate = false
    },
    //开启loading
    showLoading() {
      this.loadingInstance.show();
    },
    //关闭loading
    closeLoading() {
      this.loadingInstance.close();
    },
    confirmHandler() {
      console.log('confirm');
      this.getHideColumnKeys()
          .then(res => {
            if(this.$refs.tableRef) {
              this.$refs.tableRef.showColumnsByKeys(this.defaultShowColumnKeys)
              this.$refs.tableRef.hideColumnsByKeys(res)
            }
            this.dialogVisible = false
            console.log(this.defaultShowColumnKeys);
            if(this.tableKey) {
              localStorage.setItem(this.tableKey, JSON.stringify(this.defaultShowColumnKeys))
            }
            // this.$emit('setHeaderHandler',this.defaultShowColumnKeys)
          })

    },
    initTableHeader() {
      if(this.defaultShowColumn.length || this.defaultShowColumnKeys.length) {
        this.getHideColumnKeys()
            .then(res => {
              this.$refs.tableRef.showColumnsByKeys(this.defaultShowColumnKeys)
              this.$refs.tableRef.hideColumnsByKeys(res)
              this.dialogVisible = false
            })
      }else {
        this.defaultShowColumnKeys = this.tableItem.map(item => {
          return item.key
        })
      }
    },
    getHideColumnKeys() {
      return new Promise(resolve => {
        let arr = []
        this.tableItem.forEach(item => {
          if(this.defaultShowColumnKeys.indexOf(item.key) === -1) {
            arr.push(item.key)
          }
        })
        resolve(arr)
      })
    },
    handlerCheckBoxChange(value) {
      let checkCount = value.length
      this.checkAll = checkCount === this.tableItem.length
      this.isIndeterminate = checkCount > 0 && checkCount < this.tableItem.length
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.$emit('handleSelectionChange',this.multipleSelection)
    },
    eventHandler (scope, item) {
      eval(item.function())
    },
  }
}
</script>
<style lang="scss">

.ve-table .ve-table-container {
  height: 100% !important;
}
.vetable-container {
  .el-checkbox {
    line-height: 40px;
    min-width: 100px;
  }
  .el-checkbox-group {
    padding: 0 10px;
    background:linear-gradient(#f6f6f6 50%,transparent 0px);
    background-size:auto 81px;
    background-origin:content-box;
  }

}
.opration-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
<style scoped>
.empty-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100%;
  color: #666;
  font-size: 16px;
  border: 1px solid #eee;
  border-top: 0;
}

</style>